// @flow

// Environments
// development is localhost:8080 (webpack)
// staging is training.usccadev.com
// production is training.usconcealedcarry.com
export const DEV: string = "development";
export const STAGING: string = "staging";
export const PROD: string = "production";
